import React from 'react';
import { I18n } from 'react-redux-i18n';
import { StatusBadgeGroup } from '../../../components/common/StatusBadge';
import { saleTypeSettings } from '../constants';
import { OFFLINE_SALE_TYPE } from '../../campaign/constants';

import CurrencyHelper from '../../../helpers/currencyHelper';
import CurrencyDisplay from '../../../components/common/CurrencyDisplay';

interface ITicketingStatusProps {
  ticketData: any;
  displayOrgCurrency: boolean;
}

export const TicketingStatus = ({ ticketData, displayOrgCurrency }: ITicketingStatusProps) => {
  if (!ticketData) {
    return null;
  }
  const currency = displayOrgCurrency ? ticketData.organization.currency : ticketData.currency;
  const amountString = CurrencyHelper.formatCurrency(
    displayOrgCurrency
      ? ticketData.amount * ticketData.financials.exchangeRate
      : ticketData.amount,
    currency
  );
  const financials = ticketData?.financials || {};
  const type = ticketData.type;
  const isOffline = type == OFFLINE_SALE_TYPE;

  const { returned: cancelled, refunded, partiallyRefunded } = financials;

  const nonSuccessfulStatus = cancelled || refunded || partiallyRefunded;

  return (
    <div style={{ width: '100%' }}>
      <div>{I18n.t('ticketing.edit.titles.header')}</div>
      <div className="sale-header">
        <h1>
          <CurrencyDisplay 
            amount={amountString}
            currency={currency}
            showCurrency={true}
          />
        </h1>
      </div>
      <StatusBadgeGroup
        className="sale-status-container"
        style={{ marginTop: '8px' }}
        badges={[
            !nonSuccessfulStatus && {
              label: saleTypeSettings.SUCCESS.title,
              colorVariant: 'success' as const,
              className: 'sale-type',
              testId: 'sale-status-success'
            },
            isOffline && {
              label: saleTypeSettings.OFFLINE.title,
              colorVariant: 'neutral' as const,
              className: 'sale-type',
              testId: 'sale-status-offline'
            },
            cancelled && {
              label: saleTypeSettings.CANCELLED.title,
              colorVariant: 'error' as const,
              className: 'sale-type',
              testId: 'sale-status-cancelled'
            },
            refunded && {
              label: saleTypeSettings.REFUNDED.title,
              colorVariant: 'neutral' as const,
              className: 'sale-type',
              testId: 'sale-status-refunded'
            },
            partiallyRefunded && {
              label: saleTypeSettings.PARTIALLY_REFUNDED.title,
              colorVariant: 'neutral' as const,
              className: 'sale-type',
              testId: 'sale-status-partial-refunded'
          }
        ]}
      />
    </div>
  );
};